import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import HomePage from './pages/HomePage/HomePage';
import InvocationsPage from './pages/InvocationsPage/InvocationsPage';
import FatwasPage from './pages/FatwasPage/FatwasPage';
import ArticlesPage from './pages/ArticlesPage/ArticlesPage';
import RuqyaPage from './pages/RuqyaPage/RuqyaPage';
import RecommandationsPage from './pages/RecommandationsPage/RecommandationsPage';
import UmraGuidePage from './pages/UmraGuidePage/UmraGuidePage';
import HajjGuidePage from './pages/HajjGuidePage/HajjGuidePage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import InstallPrompt from './components/InstallPrompt';
import { Analytics } from './utils/analytics';
import './App.css';

// Composant pour tracker les changements de page
const PageTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const getPageTitle = (pathname: string) => {
      switch (pathname) {
        case '/': return 'Accueil';
        case '/articles': return 'Articles';
        case '/ruqya-sorcellerie': return 'Ruqya contre la sorcellerie';
        case '/recommandations-epreuve': return 'Conseils pour celui qui est éprouvé';
        case '/invocations-soucis': return 'Invocations contre les soucis';
        case '/fatwa/zakat': return 'Fatwas sur la Zakat';
        case '/guide-umra': return "Guide de la 'Umra";
        case '/guide-hajj': return "Guide du Ḥajj";
        default:
          // Gestion des articles individuels
          if (pathname.startsWith('/articles/')) {
            return 'Article';
          }
          return 'Page inconnue';
      }
    };

    const pageTitle = getPageTitle(location.pathname);
    const fullUrl = window.location.origin + location.pathname;
    
    // Track page view
    Analytics.pageview(fullUrl, pageTitle);
    Analytics.trackPageVisit(pageTitle);
  }, [location]);

  return null;
};

const App: React.FC = () => {
  return (
    <Router>
      <PageTracker />
      <InstallPrompt />
      <div className="app">
        <Routes>
          {/* Page d'accueil */}
          <Route path="/" element={<HomePage />} />
          
          {/* Page des articles */}
          <Route 
            path="/articles" 
            element={<ArticlesPage />} 
          />
          
          {/* Page d'un article spécifique */}
          <Route 
            path="/articles/:articleId" 
            element={<ArticlesPage />} 
          />
          
          {/* Page de ruqya contre la sorcellerie */}
          <Route 
            path="/ruqya-sorcellerie" 
            element={<RuqyaPage />} 
          />
          
          {/* Page de recommandations pour celui qui est éprouvé */}
          <Route 
            path="/recommandations-epreuve" 
            element={<RecommandationsPage />} 
          />
          
          {/* Page d'invocations contre les soucis */}
          <Route 
            path="/invocations-soucis" 
            element={<InvocationsPage />} 
          />
          
          {/* Page des fatwas sur la Zakat */}
          <Route 
            path="/fatwa/zakat" 
            element={<FatwasPage />} 
          />
          
          {/* Page Guide de la 'Umra */}
          <Route
            path="/guide-umra"
            element={<UmraGuidePage />}
          />

          {/* Page Guide du Ḥajj */}
          <Route
            path="/guide-hajj"
            element={<HajjGuidePage />}
          />

          {/* Futures routes - faciles à ajouter plus tard */}
          {/* 
          <Route 
            path="/invocations-protection" 
            element={<InvocationsPage dataFile="invocations-protection.json" />} 
          />
          */}
          
          {/* Page 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
